import {useTranslationWithOverride} from "components/src/hook/UseTranslationWithOverride";
import {SideBar} from 'components/src/sidebar/SideBar'
import {Home as DashboardIcon, PrivacyPolicy as PdfIcon} from "iconoir-react";

/**
 * AppSidebar component provides the main navigation sidebar of the application.
 */
export const PortalSidebar = () =>
{
    /**
     * i18next translation hook
     */
    const {t} = useTranslationWithOverride();

    return (
        <SideBar>
            <SideBar.Item title={t('portal-dashboard-title')} link="/" icon={<DashboardIcon/>}/>
            <SideBar.Item title={t('portal.sidebar.pdf-password-title')} link="/pdf/otp" icon={<PdfIcon/>}/>
        </SideBar>
    )
}
